export default __webpack_public_path__ + "static/media/0b863dd7.svg";